import React, { useEffect, useRef, useState } from 'react'
import "./RoleDivision.css"
import * as Sentry from "@sentry/react";


import { ChannelkartNetworkDelete, ChannelkartNetworkGet } from '../../services/networkService';
import { DataGrid, GridColDef, GridColumnHeaderParams, GridRenderCellParams, GridRowProps } from '@mui/x-data-grid';
import { Box, Tab, TextField, Tooltip } from '@mui/material';

import { roleDivisionMapping } from './RoleDivisionMapping';
import { Button, Modal } from "@mui/material";
import RoleDivisionModal from '../../components/roleDivisionComponent/RoleDivisionModal';
import { RoleDivisionModalTypes } from './types';
import { GenericPopUp } from '../../components/popup/genericPopUp';
import { popupType } from '../../types/types';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import DivisionBulkUpload from '../../components/roleDivisionComponent/DivisionBulkUpload';
import GenericTree from '../../components/roleDivisionComponent/GenericTree';
import { ConfirmationPopUp } from '../../components/popup/confirmationPopUp';
import DefaultHeading from '../../components/heading/DefaultHeading';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';


type TreeDataType = {
	name: string;
	children: TreeDataType[];
};

function RoleDivision() {
	const { translate } = usePortalTranslation();
	const CUR_COMPONENT = "Division"
	const CUR_COMPONENT_COMMON="commonPortal";
	const openPopup = (message: string, type: popupType) => {
		setPopupType(type)
		setGenericMessage(message)
		setOpenGenericModal(true)
	}
	const defaultModalData: RoleDivisionModalTypes = {
		editDivision: false,
		id: '',
		divisionName: '',
		parent: 'admin',
		possibleParents: [],
		permissionGroup: [],
		roleAccessType: '',
		channelHierarchy: false,
		close: () => toggleModal(false),
		openPopup: openPopup,
		refreshPage: refreshPage
	}
	const [rows, setRows] = useState([]);
	const [allDivisionData, setAllDivisionData] = useState([]);

	const [openModal, toggleModal] = useState(false);

	const [divisionModalData, setDivisionModalData] = useState<RoleDivisionModalTypes>(defaultModalData)

	const [genericMessage, setGenericMessage] = useState("");
	const [popupType, setPopupType] = useState<popupType>("Alert");
	const [openGenericModal, setOpenGenericModal] = useState(false);
	const [tabValue, setTabValue] = useState<string>('1');
	const [confirmPopupState, setConfirmPopupState] = useState(false)
	const [treeData, setTreeData] = useState<TreeDataType>({
		name: 'Root',
		children: []
	});
	const [popUpMessage, setPopUpMessage] = useState<string>("");

	const popUpSuccessMethod = useRef<() => void>();


	const updateConfirmationPopData = (
		message: string,
		methodHelper: () => void
	) => {
		popUpSuccessMethod.current = methodHelper;
		setPopUpMessage(message);
		setConfirmPopupState(true);
	};


	const openAddModal = () => {
		setDivisionModalData({ ...defaultModalData, possibleParents: divisionModalData.possibleParents });
		toggleModal(true);
	}

	const deleteDivision = async (divisionName: string, parentName: string,) => {
		const parentStr = parentName.replace(/ /g, "%20");
		const divisionString = divisionName.replace(/ /g, "%20");
		const url = `/v1/divisions/${divisionString}/${parentStr}`

		try{
			const deleteRes = await ChannelkartNetworkDelete(url)
			if (deleteRes.status == 200) {
				openPopup('Successfully Deleted', 'Success')
			} else if (deleteRes.status == 400) {
				openPopup('error', 'Error')
			}
		}catch(err){
			openPopup('Something Went Wrong!', 'Error')
		}
		refreshPage();
	}

	const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
		setTabValue(newValue);
	};

	const addNodeToTree = (tree: TreeDataType, parentNodeName: string, newNode: string) => {
		for (let i = 0; i < tree.children.length; i++) {
			addNodeToTree(tree.children[i], parentNodeName, newNode);
		}
		if (tree.name === parentNodeName) {
			tree.children.push({
				name: newNode,
				children: []
			});
			return;
		}
	};




	const getRoleDivisionData = async () => {
		try {
			const response = await ChannelkartNetworkGet('/v1/divisions?sort=level:asc&size=100&source=portal&callType=scheduled');
			setAllDivisionData(response.data.features);
			setRows(response.data.features);
			let parents: string[] = [];
			let tree = {
				name: 'Root',
				children: []
			}
			response.data.features.forEach(async (element: { [key: string]: any }) => {
				var divisionName = element.divisionName;
				if (!parents.includes(divisionName)) {
					parents.push(divisionName);
				}

				addNodeToTree(tree, element.parent == 'none' ? 'Root' : element.parent, element.divisionName);
				setTreeData({ ...tree })

			});
			setDivisionModalData({ ...divisionModalData, possibleParents: parents })

		} catch (err) {
			// Sentry.captureException(err);
		}

	}

	function refreshPage() {
		getRoleDivisionData()
	}


	useEffect(() => {
		getRoleDivisionData();
	}, [])

	const columns: GridColDef[] = roleDivisionMapping.columns.map(
		(columnsMetaData) => {
			return {
				disableColumnMenu: true,
				field: columnsMetaData.mappedValue,
				headerName: translate(TranslationEnum.division,columnsMetaData.headerName.toUpperCase()),
				sortable: false,
				minWidth: 100,
				maxWidth: 200,
				flex: 1,
				headerAlign: "left",
				align: "left",
			};
		}
	);
	columns.push({
		field: "Edit",
		headerName: translate(TranslationEnum.common_portal,"EDIT").toUpperCase(),
		sortable: false,
		minWidth: 200,
		flex: 1,
		headerAlign: "left",
		align: "left",
		disableColumnMenu: true,
		renderCell: (params: GridRenderCellParams) => {
			return (
				<>
					<div
						className="edit-button"
						onClick={() => {
							setDivisionModalData({
								...divisionModalData,
								editDivision: true,
								id: params.row.id,
								divisionName: params.row.divisionName,
								parent: params.row.parent,
								permissionGroup: params.row.permissionGroups,
								roleAccessType: params.row.roleAccessType,
								channelHierarchy: params.row.channelDivision,
							})
							toggleModal(true);
						}}
					>
						<Button className='division_edit_button' variant="contained" onClick={() => { }}>{translate(TranslationEnum.common_portal,"EDIT")}</Button>

					</div>
					<div className='delete-button' onClick={() => {
						updateConfirmationPopData(
							"Are you sure want to delete the record?",
							() => {
								deleteDivision(params.row.divisionName, params.row.parent)
							}
						)
					}}>
						<Button className='division_delete_button' variant="outlined" onClick={() => { }}>{translate(TranslationEnum.common_portal,"DELETE")}</Button>
					</div>
				</>
			);
		},
	});


	const searchFields = ["divisionName", "parent", "permissionGroups", "roleAccessType"]




	return (
		<div className='role_division_container'>
			<DefaultHeading heading={translate(TranslationEnum.division,"Division")} showDefaultBackButton={true} />
			<Box sx={{ width: "100%" }} className="manage_role_tabs">
				<TabContext value={tabValue}>
					<Box sx={{ borderColor: "divider" }}>
						<TabList
							onChange={handleTabChange}
							aria-label="lab API tabs example"
							variant="fullWidth"
						>
							<Tab label={translate(TranslationEnum.division,"Master Data")} value="1" className='tab_list_manage_role' />
							<Tab label={translate(TranslationEnum.division,"Bulk Upload")} value="2" className='tab_list_manage_role' />
						</TabList>
					</Box>

					<TabPanel value="1">
						<div className='division_tree'>
							<GenericTree treeData={treeData} />
						</div>

						<div className='division_grid_title'>

							<div className='master_data_heading'>
							{translate(TranslationEnum.division,"Master Data")}
							</div>
							<Button variant="contained" onClick={openAddModal}>{translate(TranslationEnum.common_portal,"Add")}</Button>
							<div className='division_search_field'>
								<TextField
									id="outlined-basic"
									label={translate(TranslationEnum.common_portal,"Search")}
									variant="outlined"
									size="small"
									// fullWidth
									autoComplete="off"
									onChange={(e) => {
										const searchedData = e.target.value.toString().toLowerCase();
										const finalData = allDivisionData.filter((eachRow) => {
											const allValues = searchFields.map((field) => {
												return eachRow[field];
											})

											return allValues.find((eachValue: any) => {
												return eachValue?.toString().toLowerCase().includes(searchedData);
											});
										})
										setRows(finalData);
									}}
								/>
							</div>


						</div>


						<div>
							<div className='division_management_grid'>
								<DataGrid
									disableRowSelectionOnClick={true}
									sx={{
										"&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
											outline: "none !important",
										},
									}}
									autoHeight
									rows={rows ? rows : []}
									columns={columns}
									hideFooter
									hideFooterPagination
								/>
							</div>
						</div>
					</TabPanel>

					<TabPanel value="2">
						<DivisionBulkUpload openPopup={openPopup} />
					</TabPanel>
				</TabContext>
			</Box>




			<Modal
			style={{ zIndex: 80 }}
				open={openModal}
				onClose={() => { toggleModal(false); }}
			>
				<RoleDivisionModal params={divisionModalData} />
			</Modal>
			<ConfirmationPopUp
				message={popUpMessage}
				openConfirmModal={confirmPopupState}
				successMethod={popUpSuccessMethod.current}
				setOpenConfirmModal={setConfirmPopupState}
			/>
			<GenericPopUp message={genericMessage}
				type={popupType}
				openGenericModal={openGenericModal}
				setOpenGenericModal={setOpenGenericModal} />

		</div>
	)
}

export default RoleDivision